import { lazy } from 'react';
import { Navigate } from 'react-router';
import PortalLayout from 'src/layouts/PortalLayout';

const Welcome = lazy(() => import('src/views/portal/Welcome'));
const Payroll = lazy(() => import('src/views/portal/Payroll'));
const TransList = lazy(() => import('src/views/portal/TransList'));
const TransView = lazy(() => import('src/views/portal/TransView'));
const PayrollView = lazy(() => import('src/views/portal/PayrollView'));
const Profile = lazy(() => import('src/views/portal/Profile'));
const PortalTrans = lazy(() => import('src/views/portal/PortalTrans'));
const Geotag = lazy(() => import('src/views/portal/Geotag'));
const GeotagView = lazy(() => import('src/views/portal/GeotagView'));

const JobPages = lazy(() =>
  import('src/views/portal/JobPosting/Recruit/JobApp/JobPosting')
);
const RegistrationForm = lazy(() =>
  import('src/views/portal/JobPosting/Recruit/JobApp/Registration')
);
const JobDetails = lazy(() =>
  import('src/views/portal/JobPosting/Recruit/JobApp/JobDetails')
);
const UlapRecruit = lazy(() =>
  import('src/layouts/LandingPages/UlapRecruit/UlapRecruit')
);

const getPortalRoutes = (ixJCd, ixJob) => [
  {
    path: 'portal',
    element: PortalLayout,
    children: [
      {
        path: '*',
        element: Navigate,
        elementProps: {
          to:
            ixJCd && ixJob
              ? `/portal/welcome?ixJCd=${ixJCd}&ixJob${ixJob}`
              : '/portal/welcome'
        }
      },
      {
        path: '',
        element: Navigate,
        elementProps: {
          to:
            ixJCd && ixJob
              ? `/portal/welcome?ixJCd=${ixJCd}&ixJob${ixJob}`
              : '/portal/welcome'
        }
      },
      {
        path: '/portal/geotag',
        element: GeotagView
      },
      {
        path: '/portal/geotag/new',
        element: Geotag
      },
      {
        path: 'welcome',
        element: Welcome
      },
      {
        path: 'profile',
        element: Profile
      },
      {
        path: 'payroll/:ixJCd',
        element: Payroll
      },
      {
        path: 'trans/:ixJCd',
        element: TransList
      },
      {
        path: 'payroll/:ixJCd/:jid',
        element: PayrollView
      },
      {
        path: 'trans/:ixJCd/:jid/view',
        element: TransView
      },
      {
        path: 'trans/:ixJCd/new',
        element: PortalTrans
      },
      {
        path: 'jobs',
        element: JobPages
      },
      {
        path: 'job-details/:ixJob',
        element: JobDetails
      },
      {
        path: 'ulap-recruit',
        element: UlapRecruit
      },
      {
        path: 'register',
        element: RegistrationForm
      }
    ]
  },
  {
    path: '/',
    element: PortalLayout,
    children: [
      {
        path: 'jobs',
        element: JobPages
      },
      {
        path: 'job-details/:ixJob',
        element: JobDetails
      },
      {
        path: 'ulap-recruit',
        element: UlapRecruit
      }

    ]
  }
];

export default getPortalRoutes;
